// @flow
import React from 'react';
import stylesheet from './Bullet.scss';

const Bullet = () => {
  return <span className={stylesheet.bullet} />;
};

export default Bullet;
